import { createContext, useContext } from 'react';

export const IsSsrMobileContext = createContext(false);

export function isMobileUserAgent(userAgent: string): boolean {
  return /android|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent);
}

export const useIsSsrMobile = (): boolean => {
  return useContext(IsSsrMobileContext);
};
